var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3633 2C19.3277 2 20.2526 2.38349 20.9346 3.06543C21.6165 3.74738 22 4.6723 22 5.63672V18.3633C22 19.3277 21.6165 20.2526 20.9346 20.9346C20.2526 21.6165 19.3277 22 18.3633 22H5.63672C4.67229 22 3.74738 21.6165 3.06543 20.9346C2.38348 20.2526 2 19.3277 2 18.3633V5.63672C2 4.6723 2.38348 3.74738 3.06543 3.06543C3.74738 2.38348 4.67229 2 5.63672 2H18.3633ZM10.4658 12.7734L5 18.9902H6.23535L11.0137 13.5537L14.8311 18.9902H19L13.332 10.918L18.5439 4.99023H17.3086L12.7832 10.1367L9.16895 4.99023H5L10.4658 12.7734ZM12.1328 10.877L12.6865 11.6514L17.3096 18.1211H15.4121L11.6406 12.8418L11.0869 12.0664L6.67969 5.89941H8.57715L12.1328 10.877Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Twitter.54c6def706dc9a4d6601d0815b3ee15a.svg";